import { AuthTokenStorage } from "../../../auth/AuthTokenStorage";

export interface JobStatusResponse {
    jobId: string;
    status: "queued" | "running" | "succeeded" | "failed";
    totalSteps: number;
    statusUrl: string;
    errorData?: {
        message: string;
        timestamp: string;
    };
    currentStepDescription?: string;
}

export class JobStatusService {
    /**
     * @param jobId
     * @returns Promise<JobStatusResponse>
     */
    static async getJobStatus(jobId: string): Promise<JobStatusResponse> {
        if (!jobId) {
            throw new Error("No jobId provided");
        }

        const token = AuthTokenStorage.get();
        const baseUrl = process.env.REACT_APP_BACKEND_URL || process.env.BACKEND_URL;
        const url = `${baseUrl}/api/v1/projects/jobs/${jobId}`;

        const response = await fetch(url, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch job status");
        }

        return response.json();
    }
}
